import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PatientsPage from './pages/PatientsPage';
import CandidatesPage from './pages/CandidatesPage';
import ActivityLogPage from './pages/ActivityLogPage';
import AlertsPage from './pages/AlertsPage';
import DeliveriesPage from './pages/DeliveriesPage';
import TeamPage from './pages/TeamPage';
import SettingsPage from './pages/SettingsPage';
import ReportsPage from './pages/ReportsPage';
import AccountPage from './pages/AccountPage';
import BillingPage from './pages/BillingPage';
import SignupPage from './pages/SignupPage';

function PrivateRoute({ children, allowedRoles }) {
  const { user, role, loading } = useAuth();
  if (loading) return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', color: '#94A3B8', fontFamily: 'Inter, system-ui, sans-serif',
      fontSize: 14 }}>Loading...</div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(role)) return <Navigate to="/dashboard" replace />;
  return children;
}

const ADMIN     = ['admin', 'superadmin'];
const STAFF     = ['admin', 'pharmacist', 'superadmin'];
const ALL_ROLES = ['admin', 'pharmacist', 'technician', 'superadmin'];

export default function App() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', color: '#94A3B8', fontFamily: 'Inter, system-ui, sans-serif',
      fontSize: 14 }}>Loading...</div>
  );
  return (
    <Routes>
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/dashboard" element={<PrivateRoute allowedRoles={ALL_ROLES}><Layout><DashboardPage /></Layout></PrivateRoute>} />
      <Route path="/dashboard/alerts" element={<PrivateRoute allowedRoles={ALL_ROLES}><Layout><AlertsPage /></Layout></PrivateRoute>} />
      <Route path="/dashboard/deliveries" element={<PrivateRoute allowedRoles={ALL_ROLES}><Layout><DeliveriesPage /></Layout></PrivateRoute>} />
      <Route path="/dashboard/account" element={<PrivateRoute allowedRoles={ALL_ROLES}><Layout><AccountPage /></Layout></PrivateRoute>} />
      <Route path="/dashboard/patients" element={<PrivateRoute allowedRoles={STAFF}><Layout><PatientsPage /></Layout></PrivateRoute>} />
      <Route path="/dashboard/candidates" element={<PrivateRoute allowedRoles={STAFF}><Layout><CandidatesPage /></Layout></PrivateRoute>} />
      <Route path="/dashboard/activity" element={<PrivateRoute allowedRoles={STAFF}><Layout><ActivityLogPage /></Layout></PrivateRoute>} />
      <Route path="/dashboard/reports" element={<PrivateRoute allowedRoles={STAFF}><Layout><ReportsPage /></Layout></PrivateRoute>} />
      <Route path="/dashboard/team" element={<PrivateRoute allowedRoles={ADMIN}><Layout><TeamPage /></Layout></PrivateRoute>} />
      <Route path="/dashboard/settings" element={<PrivateRoute allowedRoles={ADMIN}><Layout><SettingsPage /></Layout></PrivateRoute>} />
      <Route path="/dashboard/billing" element={<PrivateRoute allowedRoles={ADMIN}><Layout><BillingPage /></Layout></PrivateRoute>} />
      <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} replace />} />
    </Routes>
  );
}
